export const theme = {
	dark: {
		background: '#161617',
		highlightBackground: '#1e1e1f',
		menuBackground: 'rgba(29, 29, 31, 0.85)',
		title: '#f5f5f7',
		para: '#a1a1a6',
		sideIcons: '#a1a1a6',
		shadow: 'rgba(0, 0, 0, 0.2)',
		line: '#424245',
	},
	light: {
		background: '#f9f9f9',
		highlightBackground: '#ffffff',
		menuBackground: 'rgba(255, 255, 255, 0.85)',
		title: '#1d1d1f',
		para: '#515154',
		sideIcons: '#515154',
		shadow: 'rgba(0, 0, 0, 0.05)',
		line: '#e5e5e5',
	},
};
